import { Controller } from '@hotwired/stimulus'
import { formatHours } from '../shared/util/format'

export default class extends Controller {
  static targets = ['sectorId', 'schoolyearId', 'percentage', 'hourbank', 'totalHours', 'categoryHour', 'subHourBank']

  connect() {
    setTimeout(() => this.updateHours(), 0)
  }

  activeCategories() {
    const schoolyearId = Number(this.schoolyearIdTarget.value)

    const activeCategoryIds = new Set(window.gon.categories_by_schoolyear[schoolyearId] || [])

    return window.gon.categories.filter((c) => activeCategoryIds.has(c.id))
  }

  updateHours() {
    let formValid = true
    let totalHours = 0

    const percentage = Math.max(Math.min(Number(this.percentageTarget.value), 100), 0)
    const schoolyearId = Number(this.schoolyearIdTarget.value)
    const activeCategoryIds = new Set(window.gon.categories_by_schoolyear[schoolyearId] || [])

    // Show/hide sub-hour-bank fieldsets based on active categories for the selected schoolyear
    this.subHourBankTargets.forEach((subHourBankFormTarget) => {
      const categoryId = Number(subHourBankFormTarget.getAttribute('data-sub-hour-bank-form-category-id-value'))

      const isActive = !schoolyearId || activeCategoryIds.has(categoryId)

      subHourBankFormTarget.hidden = !isActive

      if (isActive) {
        subHourBankFormTarget.setAttribute('data-sub-hour-bank-form-sector-id-value', this.sectorIdTarget.value)
        subHourBankFormTarget.setAttribute('data-sub-hour-bank-form-schoolyear-id-value', this.schoolyearIdTarget.value)
        subHourBankFormTarget.setAttribute('data-sub-hour-bank-form-percentage-value', percentage)
        this.application.getControllerForElementAndIdentifier(subHourBankFormTarget, 'sub-hour-bank-form').updateHours()
      }
    })

    // Show/hide category hour rows and compute totals
    window.gon.categories.forEach((category) => {
      const isActive = !schoolyearId || activeCategoryIds.has(category.id)
      const categoryTarget = this.categoryHourTargets.find((target) => target.attributes['data-category-id'].value == category.id)

      // Show/hide the table row
      if (categoryTarget) {
        const row = categoryTarget.closest('tr')

        if (row) {
          row.hidden = !isActive
        }
      }

      if (!isActive) {
        return
      }

      const hourBankKey = [category.id, this.sectorIdTarget.value, this.schoolyearIdTarget.value].join(',')
      const hourBank = window.gon.hour_banks[hourBankKey]
      let hourText

      if (hourBank === undefined || Number.isNaN(percentage)) {
        formValid = false
      } else {
        const hourTotal = (percentage * hourBank.hours) / 100

        hourText = formatHours(hourTotal)
        totalHours += hourTotal
      }

      if (categoryTarget) {
        categoryTarget.textContent = hourText
      }
    })

    this.totalHoursTarget.textContent = formatHours(totalHours)
    this.hourbankTarget.hidden = !formValid
  }
}
